import { REFRESH_ALL_STATE } from '../types';

export const refreshAllState = (data) => (dispatch) => {
  dispatch({
    type: REFRESH_ALL_STATE,
    payload: data,
  });
};
